import api from 'api/apiInstance';

export function clientCaseFactFindPrintApi(path: string) {
  return {
    path,
    GET: () => api.get<File>(path),
  };
}
